import { Link, useParams } from "react-router-dom";
import { useContext } from "react";
import UserContext from "../../services/Context/UserContext"
import menus from "../../config/menus";
import { Typography } from "@mui/material";

export default function Menu({menu, tab}){

    const {user} = useContext(UserContext)

    const params = useParams()

    const group = menus[menu] || menus.main;

    const match = tab => Array.isArray(tab.roles) ? tab.roles.some(r => user.roles.includes(r)) : true;

    const replaceParams = path => {
        return path.replace(/:(\w+)/g, (match, variable) => {
            return params.hasOwnProperty(variable) ? params[variable] : match;
        });
    }

    return <div className="layout-menu">

        {group.title &&
            <Typography className="layout-menu-title" variant='h3'>
                {group.title}
            </Typography>
        }

        {group.tabs
            .filter(t => match(t))
            .map(t => t.external ? 

                <a
                    href={replaceParams(t.path)}
                    className={'layout-tab-' + (t.id === tab ? 'on' : 'off')}
                    key={t.id}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {t.icon} 
                    <Typography>{t.title}</Typography>
                </a>

                :

                <Link
                    to={replaceParams(t.path)}
                    className={'layout-tab-' + (t.id === tab ? 'on' : 'off')}
                    key={t.id}
                >
                    {t.icon} 
                    <Typography>{t.title}</Typography>
                </Link>    
            )
        }

    </div>
}